import React from 'react';
export function BottomLinksSection() {
  return <div className="text-center pt-8 border-t border-gray-200" data-id="element-2323">
      <div className="flex flex-wrap justify-center items-center gap-6 text-xl font-bold" data-id="element-2324">
        <a href="https://www.peakedm.com/MikronHighSpeedMilling.html#3Axis" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline" data-id="element-2325">
          Mikron High Speed 3-Axis
        </a>
        <span className="text-gray-400" data-id="element-2326">|</span>
        <a href="https://www.peakedm.com/MikronHighSpeedMilling.html#5Axis" target="_blank" rel="noopener noreferrer" className="text-orange hover:underline" data-id="element-2327">
          Mikron High Speed 5-Axis
        </a>
      </div>
    </div>;
}